const CustomTheme = {
  // https://developers.arcgis.com/calcite-design-system/foundations/colors/#modes
  color: {
    brand: '#007472',
    brandLight: '#07CDCA', // Chart lines and model view links/ports
    brandHover: '#004D4C',
    brandHoverLight: '#E8F2F2', // Hover or highlight background (table, grid, metrics)
    brandPress: '#003C3B',
    background: '#F8F8F8',
    foreground1: '#FFFFFF',
    foreground2: '#F3F3F3',
    foreground3: '#EAEAEA',
    text1: '#151515',
    text2: '#4A4A4A',
    text3: '#6A6A6A',
    textInverse: '#FFFFFF',
    textLink: '#005c5a',
    border1: '#CACACA',
    border2: '#D4D4D4',
    border3: '#DFDFDF',
    borderInput: '#949494',
    info: '#00619B',
    success: '#35AC46',
    warning: '#EDD317',
    danger: '#D83020',
    dangerHover: '#A82B1E',
    dangerPress: '#7C1D13'
  },
  // https://developers.arcgis.com/calcite-design-system/foundations/typography/#size--weight
  font: {
    size0: '1rem',
    size1: '0.875rem',
    size2: '0.75rem',
    weightMedium: 500,
    weightNormal: 400,
    avenirFamily:
      '"Avenir Next W01", "Avenir Next W00", "Avenir Next", "Avenir", "Helvetica Neue", sans-serif',
    codeFamily: '"Consolas","Andale Mono","Lucida Console","Monaco",monospace;'
  },
  baseline: '1.55rem',
  boxShadow: 'rgba(0, 0, 0, 0.15) 0px 0px 16px 0px'
};

export default CustomTheme;
